// src/components/settingsContents/PasswordContent.js

import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import axiosInstance from '../../axiosInstance';

const PasswordContent = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    // Password validation
    const hasMinLength = newPassword.length >= 8;
    const hasUppercase = /[A-Z]/.test(newPassword);
    const hasLowercase = /[a-z]/.test(newPassword);
    const hasNumber = /[0-9]/.test(newPassword);
    const passwordsMatch = newPassword === confirmPassword && confirmPassword.length > 0;
    
    const isFormValid = 
        currentPassword.length > 0 &&
        hasMinLength &&
        hasUppercase &&
        hasLowercase &&
        hasNumber &&
        passwordsMatch;

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!isFormValid) return;

        setIsLoading(true);
        setMessage({ type: '', text: '' });

        try {
            await axiosInstance.put('/api/change-password/', {
                old_password: currentPassword,
                new_password: newPassword,
            });

            setMessage({ 
                type: 'success', 
                text: 'Dein Passwort wurde erfolgreich geändert.' 
            });
            
            // Reset form
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (error) {
            const errorMessage = error.response?.data?.detail || 
                error.response?.data?.old_password?.[0] ||
                error.response?.data?.new_password?.[0] ||
                'Ein Fehler ist aufgetreten. Bitte versuche es erneut.';
            
            setMessage({ type: 'error', text: errorMessage });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <h2 className="settings-card-title">Passwort ändern</h2>
            <p className="settings-card-description">
                Aktualisiere Dein Passwort, um Deinen Account sicher zu halten.
            </p>

            {message.text && (
                <div className={`settings-message ${message.type}`}>
                    {message.text}
                </div>
            )}

            <form className="settings-form" onSubmit={handleSubmit}>
                <div className="settings-form-group">
                    <label className="settings-form-label" htmlFor="currentPassword">
                        Aktuelles Passwort
                    </label>
                    <input
                        type="password"
                        id="currentPassword"
                        className="settings-form-input"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        placeholder="Aktuelles Passwort eingeben"
                        disabled={isLoading}
                    />
                </div>

                <div className="settings-form-group">
                    <label className="settings-form-label" htmlFor="newPassword">
                        Neues Passwort
                    </label>
                    <input
                        type="password"
                        id="newPassword"
                        className="settings-form-input"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Neues Passwort eingeben"
                        disabled={isLoading}
                    />
                </div>

                <div className="settings-form-group">
                    <label className="settings-form-label" htmlFor="confirmPassword">
                        Neues Passwort bestätigen
                    </label>
                    <input
                        type="password"
                        id="confirmPassword"
                        className="settings-form-input"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Neues Passwort wiederholen"
                        disabled={isLoading}
                    />
                </div>

                {newPassword.length > 0 && (
                    <div className="password-requirements">
                        <p className="password-requirements-title">Passwortanforderungen:</p>
                        <ul className="password-requirements-list">
                            <li className={hasMinLength ? 'valid' : ''}>
                                Mindestens 8 Zeichen
                            </li>
                            <li className={hasUppercase ? 'valid' : ''}>
                                Mindestens ein Großbuchstabe
                            </li>
                            <li className={hasLowercase ? 'valid' : ''}>
                                Mindestens ein Kleinbuchstabe
                            </li>
                            <li className={hasNumber ? 'valid' : ''}>
                                Mindestens eine Zahl
                            </li>
                            <li className={passwordsMatch ? 'valid' : ''}>
                                Passwörter stimmen überein
                            </li>
                        </ul>
                    </div>
                )}

                <button
                    type="submit"
                    className="settings-btn settings-btn-primary"
                    disabled={!isFormValid || isLoading}
                    style={{ marginTop: '24px' }}
                >
                    {isLoading ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Wird gespeichert...
                        </>
                    ) : (
                        'Passwort ändern'
                    )}
                </button>
            </form>
        </>
    );
};

export default PasswordContent;
